<template>
  <section>
    <h2 class="text-h2 mb-32">Background Checks Made Simple</h2>
    <div v-for="(section, i) in sections" :key="`section-${i}`">
      <h3 class="text-h3 mb-16">{{ section.header }}</h3>
      <accordion-row
        v-for="(question, j) in section.questions"
        :key="`${i}-${j}`"
        class="mb-16"
        :label="question.question"
        expand-icon-color="#99005c"
      >
        <template #accordion-content>
          <p class="text-body text-grey-body">{{ question.answer }}</p>
        </template>
      </accordion-row>
    </div>
  </section>
</template>

<script lang="ts">
import AccordionRow from '@/components/accordion_row/AccordionRow.vue';

export default {
  name: 'BGCQuestions',
  components: {
    AccordionRow,
  },
  data() {
    return {
      sections: [
        {
          header: 'How it works',
          questions: [
            {
              question: 'How do I request a background check?',
              answer:
                'Visit the sitter’s profile and select Run Background Check from the Trust & Safety section. Choose the check that’s right for your family then submit your request.',
            },
            {
              question: 'How long does it take?',
              answer:
                'Most background checks are completed within 3 days, though it could take longer, depending on the records being reviewed.',
            },
            {
              question: 'What happens next?',
              answer:
                'Your sitter will receive the request and have 3 days to accept and complete it. Once the check is finished, their profile badge will be updated. We’ll let you know if they decline or don’t complete the request.',
            },
          ],
        },
        {
          header: 'Viewing Results',
          questions: [
            {
              question: 'Will I get a copy of the report?',
              answer:
                'Due to privacy laws, Sittercity can’t share the full report directly with families. Instead, results will appear as a badge on the sitter’s profile. Sitters receive a copy of their report and they can choose to share it with you.',
            },
            {
              question: 'How do I see the results?',
              answer:
                'Once the check is complete, you’ll see a background check badge on the sitter’s profile along with additional badge details.',
            },
            {
              question: 'How long is a badge valid?',
              answer:
                'Background check badges remain active for 90 days. After that, you can request a new check if you’d like updated results.',
            },
          ],
        },
        {
          header: 'What Your Sitter Sees',
          questions: [
            {
              question: 'Will my sitter know I requested a background check?',
              answer:
                'Yes. Sitters are notified when you submit a request and they must accept it before the screening can begin.',
            },
            {
              question: 'What if my sitter doesn’t respond?',
              answer:
                'If the sitter declines the request or doesn’t complete it within 3 days, we’ll let you know. You won’t be charged if the check isn’t completed.',
            },
          ],
        },
      ],
    };
  },
};
</script>
